export const WebSkills = [
  {
    title: 'Javascript Development',
    description: 'Rich JavaScript development utilising the latest JavaScript technologies including ES6+ and React JS.',
    icon: {
      color: '#efd528',
      classCode: 'fab fa-js'
    }
  },
  {
    title: 'Front End Development',
    description: 'Extensive knowledge of front end development languages including the latest HTML5 and CSS3 techniques.',
    icon: {
      color: '#e54d27',
      classCode: 'fab fa-html5'
    }
  },
  {
    title: 'Server Side Programming',
    description: 'Secure server side programming with the latest technologies including Node.js and ASP.NET Core.',
    icon: {
      color: '#539e43',
      classCode: 'fab fa-node-js'
    }
  },
  {
    title: 'Responsive Web Applications',
    description: 'Targeted development for variety of devices including mobile phones, tablets and desktop computers.',
    icon: {
      color: '#b12bb0',
      classCode: 'fas fa-mobile-alt'
    }
  },
  {
    title: 'User Interface Design',
    description: 'Ability to innovate and create customised designs for clients using various graphic design software.',
    icon: {
      color: '#ee6163',
      classCode: 'fas fa-paint-brush'
    }
  },
  {
    title: 'SEO & Analytics',
    description: 'Experience carrying out SEO techniques combined with web analytics to boost client website standings within search engines.',
    icon: {
      color: '#0791cd',
      classCode: 'fas fa-chart-line'
    }
  }
];

export const PhotoEditingSkills = [
  {
    title: 'Photo Enhancement',
    description: 'Correcting exposure & white balance are just the beginning. I can transform your photographs into a work of art.',
    icon: {
      color: '#b12bb0',
      classCode: 'fas fa-camera-retro'
    }
  },
  {
    title: 'Object Removal',
    description: 'Unwanted objects or individuals in the background of your photos? don\'t let that ruin your great shots!',
    icon: {
      color: '#e54d27',
      classCode: 'fas fa-cut'
    }
  },
  {
    title: 'Product Image Masking',
    description: 'Background removal, subject masking, retouching, cloning, cropping, resizing & aligning. You name it!',
    icon: {
      color: '#0791cd',
      classCode: 'fas fa-cube'
    }
  }
];



// WEBPACK FOOTER //
// ./src/components/digitalNomad/MySkills.js